export { default } from './DotSeparator';
